import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M739.6771 0.10399l56.592805 56.591806-455.3562 455.355199 455.3552 455.3552-56.591805 56.591805-511.947005-511.947005z\" p-id=\"1935\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/left.svg
// module id = Hejy
// module chunks = 31